import { CandidateStatus, ICandidateProfessionalEntity } from '~/domain/PermanentJobs';
import { useToggle } from '~/hooks';

interface IUseRejectCandidate {
  candidate: ICandidateProfessionalEntity | undefined;
}

export const useRejectCandidate = ({ candidate }: IUseRejectCandidate) => {
  const [isOpen, controls] = useToggle();

  const isHired = candidate?.officeStatus === CandidateStatus.Hired;
  const isRejected = candidate?.officeStatus === CandidateStatus.Rejected;

  const canReject = !isHired && !isRejected;

  const handleRejectClick = () => {
    if (!canReject) {
      return;
    }

    controls.setOn();
  };

  return {
    canReject,
    controls,
    isOpen,
    handleRejectClick,
  };
};
